import { useTranslation } from "react-i18next";

export const useNotApplicable = (): string => {
  const { t } = useTranslation("availability", { keyPrefix: "bookings.list" });
  return t("notApplicable");
};
